import { axiosInstance } from "api/axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IEgibParcel } from "dto/Egib/IEgibParcel";
import { ICaseParcel, ILinkCaseParcelRequest } from "dto/Egib/ICaseParcel";

/**
 * Integracja EGiB (Etap 1). Wyszukiwanie działek przez ULDK (BE proxy `/egib/parcel`)
 * oraz powiązanie działek ze sprawą (`/egib/case-parcel`). Tylko dane przestrzenne.
 */

// Pobierane na żądanie (klik/wyszukiwanie), nie jako hook na montażu.
const getParcelById = async (id: string): Promise<IEgibParcel> =>
  (await axiosInstance.get<IEgibParcel>("/egib/parcel", { params: { id } })).data;

const getParcelByXY = async (x: number, y: number): Promise<IEgibParcel> =>
  (await axiosInstance.get<IEgibParcel>("/egib/parcel", { params: { x, y } })).data;

const getCaseParcels = async (caseId: string): Promise<ICaseParcel[]> =>
  (await axiosInstance.get<ICaseParcel[]>("/egib/case-parcel", { params: { caseId } }))
    .data;

const linkParcel = async (req: ILinkCaseParcelRequest): Promise<ICaseParcel> =>
  (await axiosInstance.post<ICaseParcel>("/egib/case-parcel", req)).data;

const unlinkParcel = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/egib/case-parcel/${id}`);
};

const egibService = {
  getParcelById,
  getParcelByXY,

  useGetCaseParcels: (caseId?: string) =>
    useCustomQuery<ICaseParcel[]>(
      ["egib.caseParcels", caseId ?? ""],
      () => getCaseParcels(caseId as string),
      { enabled: !!caseId },
    ),

  useLinkParcel: () =>
    useCustomMutation<ICaseParcel, ILinkCaseParcelRequest>(linkParcel),

  useUnlinkParcel: () => useCustomMutation<void, string>(unlinkParcel),
};

export default egibService;
